export default __webpack_public_path__ + "static/media/help.bba15f28.svg";